<template>
  <footer class="footer-wrapper footer-layout2 space-top overflow-hidden">
    <div class="container mx-auto">
      <div class="bg-[#eae0d6] py-8 text-black">
        <div :class="[footerPadding, footerLocaleClass]">
          <div class="footer-columns flex flex-col gap-15 max-[639px]:gap-4 sm:flex-row">
            <!-- 遍历渲染导航列 -->
            <div
              v-for="section in footerNavigationSections"
              :key="section.title"
              :class="section.flexClass || 'flex-1'"
            >
              <div class="widget widget_nav_menu footer-widget">
                <!-- 修改：添加标题样式 -->
                <h3
                  class="widget_title footer-title text-lg font-semibold text-black"
                >
                  {{ section.title }}
                </h3>
                <ul class="space-y-2">
                  <li v-for="link in section.links" :key="link.text">
                    <a
                      :href="link.href"
                      :target="link.external ? '_blank' : '_self'"
                      class="text-black"
                    >
                      {{ link.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- 联系方式列 -->
            <div class="footer-contact-column flex-3">
              <div class="widget footer-widget">
                <div class="widget-contact">
                  <!-- 修改：统一样式类 -->
                  <h3
                    class="widget_title footer-title text-lg font-semibold text-black"
                  >
                    {{ footerContactInfo.title }}
                  </h3>
                  <ul class="space-y-2 text-black">
                    <li
                      v-for="(line, index) in footerContactInfo.lines"
                      :key="index"
                    >
                      {{ line }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="copyright-wrap text-center">
      <div class="container mx-auto">
        <div class="text-center">
          <span class="text-black">© COPYRIGHT ICAA 2026 .</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { useNavigation } from "@/hook/useNavigation";
import type {
  FooterLink,
  FooterSection,
  FooterContactInfo,
} from "@/hook/useNavigation";
const { locale } = useI18n();

const footerPadding = computed(() => {
  return locale.value === "zh-CN" ? "px-16" : "px-16";
});

const footerLocaleClass = computed(() => {
  return locale.value === "zh-CN" ? "footer-zh" : "footer-en";
});

const { footerNavigationSections, footerContactInfo } = useNavigation();
</script>

<style scoped>
/* 保留原有的样式 */
.footer-wrapper {
  width: 100%;
}

.space-top {
  padding-top: 80px;
}

/* 新增：Footer 标题统一样式 */
.footer-title {
  margin-bottom: 1rem; /* 16px，等同于 mb-4 */
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  min-height: auto;
  line-height: 1.75rem;
}

.footer-widget .footer-title {
  max-width: none;
}

.footer-columns {
  justify-content: space-between;
}

.footer-columns > div {
  flex: 1 1 0;
  min-width: 0;
}

.footer-columns > .footer-contact-column {
  flex: 0 1 340px;
  min-width: 0;
}

.footer-zh .footer-columns {
  gap: 2rem;
}

.footer-en .footer-columns {
  gap: 2.75rem;
}

.footer-en .footer-contact-column {
  flex: 1 1 250px;
}

.footer-en .footer-title {
  font-size: 1.08rem;
  line-height: 1.55rem;
  min-height: 1.55rem;
}

.footer-en :deep(.footer-widget a),
.footer-en :deep(.widget-contact li) {
  font-size: 0.95rem;
  line-height: 1.5;
}

/* 如果希望在小屏幕上允许换行 */
@media (max-width: 639px) {
  .footer-columns > div,
  .footer-columns > .footer-contact-column {
    flex: 0 1 auto;
  }

  .footer-zh .footer-columns {
    gap: 1rem;
  }

  .footer-title {
    white-space: normal;
  }

  .space-top {
    padding-top: 40px;
  }
}
</style>
